module.exports = __webpack_public_path__ + "static/blue-98787165fd549ad532160df1da1bec23.png";